<template>
  <div v-if="hasRun" class="ibox float-e-margins latest-run-card">
    <div class="ibox-content">
      <div class="latest-run-head">
        <div>
          <span class="latest-run-kicker">Letzter Run</span>
          <strong>{{ overallPercent }}% Gesamtfortschritt</strong>
        </div>
        <span class="latest-run-poll">
          <i :class="{'fa-spin': pollTimer !== null}" class="fa fa-refresh"></i>
          alle {{ pollIntervalMs / 1000 }}s
        </span>
      </div>

      <div class="latest-run-metrics">
        <div class="latest-run-metric">
          <div :class="finishedCount > 0 ? 'text-navy' : 'text-muted'" class="font-bold">
            {{ finishedCount }}
          </div>
          <small>Fertig</small>
        </div>
        <div class="latest-run-metric">
          <div :class="runningCount > 0 ? 'text-warning' : 'text-muted'" class="font-bold">
            {{ runningCount }}
          </div>
          <small>Aktiv</small>
        </div>
        <div class="latest-run-metric">
          <div :class="failedCount > 0 ? 'text-danger' : 'text-muted'" class="font-bold">
            {{ failedCount }}
          </div>
          <small>Fehler</small>
        </div>
      </div>

      <div class="latest-run-bar">
        <div :style="{ width: finishedPercent + '%' }"
             class="latest-run-bar-finished"></div>
        <div :style="{ width: runningPercent + '%', left: finishedPercent + '%' }"
             class="latest-run-bar-running"></div>
        <div
            :style="{ width: failedPercent + '%', left: (finishedPercent + runningPercent) + '%' }"
            class="latest-run-bar-failed"></div>
      </div>
      <div class="latest-run-foot">
        <small>
          {{ totalBuilds > 0 ? (finishedCount + failedCount) : 0 }} /
          {{ totalBuilds }} abgeschlossen
        </small>
        <small>{{ overallPercent }}%</small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasRun: {
      type: Boolean,
      required: true,
    },
    pollTimer: {
      required: true,
    },
    pollIntervalMs: {
      type: Number,
      required: true,
    },
    totalBuilds: {
      type: Number,
      required: true,
    },
    finishedCount: {
      type: Number,
      required: true,
    },
    runningCount: {
      type: Number,
      required: true,
    },
    failedCount: {
      type: Number,
      required: true,
    },
    finishedPercent: {
      type: Number,
      required: true,
    },
    runningPercent: {
      type: Number,
      required: true,
    },
    failedPercent: {
      type: Number,
      required: true,
    },
    overallPercent: {
      type: Number,
      required: true,
    },
  },
};
</script>
